<div class="dealer-intro">

	<div class="distributor-logo" *ngIf="(distributor | async).logo">
		<picture>
			<source media="(min-width: 600px)" [srcset]="(distributor | async).logo | img:'desktop':'webp':'medium_'" type="image/webp">
			<source media="(min-width: 600px)" [srcset]="(distributor | async).logo | img:'desktop':'normal':'medium_'">
			<source [srcset]="(distributor | async).logo | img:'mobile':'webp'" type="image/webp">
			<img [src]="(distributor | async).logo | img:'mobile':'normal'">
		</picture>
	</div>

	<picture class="distributor-background">
		<source media="(min-width: 600px)" [srcset]="((distributor | async).banner ? (distributor | async).banner : '/assets/dealer.jpg') | img:'desktop':'webp':''" type="image/webp">
		<source media="(min-width: 600px)" [srcset]="((distributor | async).banner ? (distributor | async).banner : '/assets/dealer.jpg') | img:'desktop':'normal':''">
		<source [srcset]="((distributor | async).banner ? (distributor | async).banner : '/assets/dealer.jpg') | img:'mobile':'webp'" type="image/webp">
		<img [src]="((distributor | async).banner ? (distributor | async).banner : '/assets/dealer.jpg') | img:'mobile':'normal'">
	</picture>

 </div>
 <div class="gutter">


	<div class="flx-dynamic flx-gap-default-forced">
		<div class="w-50-md distributor-info">

			<header class="flx-col"><h4 i18n="@@distrib_title_top1">Poznaj</h4><h1>{{ (distributor | async).title }}</h1></header>
			<app-ve *ngIf="(distributor | async)" [content]="(distributor | async).content"></app-ve>


			<div id="add(res | async)" itemscope itemtype="http://schema.org/Organization">				
				<ul>
					<li class="flx-row flx-strt-strt" *ngIf="(distributor | async).extra_1" (click)="triggerEvent($event, 'click_email')"><svg class="icon icon-mail"><use xlink:href="#icon-mail"></use></svg><ng-container i18n="@@distrib_email">E-mail:</ng-container>&nbsp;<a [href]="'mailto:'+(distributor | async).extra_1">{{ (distributor | async).extra_1 }}</a></li>
					<li class="flx-row flx-strt-strt" *ngIf="(distributor | async).extra_2" (click)="triggerEvent($event, 'click_phone')"><svg class="icon icon-phone"><use xlink:href="#icon-phone"></use></svg><ng-container i18n="@@distrib_phone">Telefon:</ng-container>&nbsp;<a [href]="'tel:'+(distributor | async).extra_2">{{ (distributor | async).extra_2 }}</a></li>
					<li class="flx-row flx-strt-strt" *ngIf="(distributor | async).extra_3" (click)="triggerEvent($event, 'click_phone')"><svg class="icon icon-mobile"><use xlink:href="#icon-mobile"></use></svg><ng-container i18n="@@distrib_phone">Telefon:</ng-container>&nbsp;<a [href]="'tel:'+(distributor | async).extra_3">{{ (distributor | async).extra_3 }}</a></li>
					<li class="flx-row flx-strt-strt" *ngIf="(distributor | async).link"><svg class="icon icon-globe"><use xlink:href="#icon-globe"></use></svg><ng-container i18n="@@distrib_www">Strona www:</ng-container>&nbsp;<a target="_blank" [href]="(distributor | async).link">{{ (distributor | async).link }}</a></li>
					<li class="flx-row flx-strt-strt" *ngIf="(distributor | async).description"><svg class="icon icon-building"><use xlink:href="#icon-building"></use></svg><ng-container i18n="@@distrib_adr">Adres:</ng-container> <span itemprop="add(res | async)" itemscope itemtype="http://schema.org/PostalAdd(res | async)" [innerHtml]="(distributor | async).description "></span></li>
					<li class="flx-row flx-strt-strt" *ngIf="(distributor | async).background"><svg class="icon icon-clock"><use xlink:href="#icon-clock"></use></svg><ng-container i18n="@@distrib_hours">Godziny otwarcia:</ng-container> <span [innerHtml]="(distributor | async).background"></span></li>
				</ul>
			</div>


			<div *ngIf="(distributor | async).photos &&  (distributor | async).photos.length">
				<header class="flx-col"><h4 i18n="@@distrib_title_gallery1">Zobacz</h4><h2 i18n="@@distrib_title_gallery2">Przyczepy Temared na naszym placu</h2></header>
				<swiper class="gallery"   #swiper [config]="config" [thumbs]="{ swiper: thumbsSwiper }">
					<ng-template swiperSlide *ngFor="let slide of (distributor | async).photos; let i = index">					
							<picture>
								<source media="(min-width: 600px)" [srcset]="slide | img:'desktop':'webp':''" type="image/webp">
								<source media="(min-width: 600px)" [srcset]="slide | img:'desktop':'normal':''">
								<source [srcset]="slide | img:'mobile':'webp'" type="image/webp">
								<img [src]="slide | img:'mobile':'normal'">
							</picture>
							<ng-container *ngIf="slide.title !== slide.alt">
								<p class="photo-description">{{ slide.title }}</p>
							</ng-container>
					</ng-template>
				</swiper>
				<swiper (swiper)="thumbsSwiper = $event"
					[spaceBetween]="8"
					[slidesPerView]="'auto'"
					[freeMode]="true"
					[watchSlidesProgress]="true"
					class="thumbs">
					<ng-template swiperSlide *ngFor="let slide of (distributor | async).photos; let i = index">				
						<picture>
							<source media="(min-width: 600px)" [srcset]="slide | img:'desktop':'webp':'cms_'" type="image/webp">
							<source media="(min-width: 600px)" [srcset]="slide | img:'desktop':'normal':'cms_'">
							<source [srcset]="slide | img:'mobile':'webp'" type="image/webp">
							<img [src]="slide | img:'mobile':'normal'">
						</picture>
						<ng-container *ngIf="slide.title !== slide.alt">
							<p class="photo-description">{{ slide.title }}</p>
						</ng-container>
					</ng-template>
				</swiper>
			</div>


			<header id="contactheader" class="flx-col"><h4 i18n="@@distrib_title_contact1">Kontakt</h4><h2 i18n="@@distrib_title_contact2">Napisz do nas</h2></header>
			<form *ngIf="form" [formGroup]="form" novalidate (submit)="submit()" class="w-100">
		
				<input type="hidden" formControlName="id_distributor">
				<input type="hidden" formControlName="namesurname">
				<div class="flx-col mt" *ngIf="(res | async) === 0">
					<mat-form-field appearance="outline">
						<mat-label i18n="@@subject">Rodzaj pytania</mat-label>
						<mat-select required formControlName="subject">
							<mat-option *ngFor="let subject of subjects" [value]="subject.value">
								{{ subject.viewValue }}
							</mat-option>
						</mat-select>
						<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
					<mat-form-field appearance="outline">
						<mat-label i18n="@@yourname">Twoje imię</mat-label>
						<input matInput required formControlName="name" >
						<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
					<div class="flx-dynamic flx-cntr-strt flx-gap-default">
						<mat-form-field class="w-100" appearance="outline">
							<mat-label i18n="@@email">Adres e-mail</mat-label>
							<input matInput required formControlName="email" >
							<mat-error i18n="@@error_mail">To pole musi być poprawnym adresem e-mail</mat-error>
						</mat-form-field>
						<mat-form-field class="w-100" appearance="outline">
							<mat-label i18n="@@phone">Telefon</mat-label>
							<input matInput required formControlName="phone" >
							<mat-error  *ngIf="form.get('phone').value == 'PL'" i18n="@@error_phone">Wprowadź poprawny numer telefonu w formacie 555444333</mat-error>
							<mat-error  *ngIf="form.get('phone').value != 'PL'" i18n="@@error_req">To pole jest wymagane</mat-error>
						</mat-form-field>
					</div>
					<mat-form-field appearance="outline">
						<mat-label i18n="@@message">Treść wiadomości</mat-label>
						<textarea matInput formControlName="message" i18n-placeholder></textarea>
						<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
					<div class="rodo-checkbox w-100" [class.error]="form.controls.rodo.invalid && form.controls.rodo.dirty">
						<label class="switch">
							<input type="checkbox" formControlName="rodo">
							<span class="switch-style"></span>
							<ng-container i18n="@@distrib_rodo">Wyrażam zgodę na przetwarzanie moich danych, w tym na udostepnienie ich wskazanemu powyżej Dealerowi, w celu otrzymywania informacji handlowych, w tym marketingowych, w odniesieniu do produktów własnych i usług, drogą elektroniczną na podany przeze mnie powyżej numer telefonu i/lub adres e-mail. Administratorem przekazanych danych osobowych będzie Temared Sp. z o.o. z/s w Świdniku, a także wskazany powyżej wybrany Dealer, któremu przekazane dane zostaną udostępnione. Dane osobowe przetwarzane będą w celu udzielenia odpowiedzi na wiadomości kierowane za pośrednictwem formularza kontaktowego. Podanie danych osobowych oraz wyrażenie zgody na ich udostępnienie jest dobrowolne, aczkolwiek niezbędne do nawiązania kontaktu za pośrednictwem formularza kontaktowego, w tym także zwybranym przez Ciebie Dealerem. Szczegółowe informacje m.in. o zakresie, sposobach, celach, czy podstawach prawnych przetwarzania przez Temared Sp. z o.o. z/s w Świdniku danych osobowych udostępniamy w Polityce prywatności naszego serwisu.</ng-container>
						</label>
						<mat-error *ngIf="form.controls.rodo.invalid && form.controls.rodo.dirty" i18n="@@rodoerror">Musisz wyrazić zgodę na przetwarzenie swoich danych osobowych.</mat-error>
					</div>
					<div class="rodo-checkbox">
						<label class="switch">
							<input type="checkbox" formControlName="newsletter">
							<span class="switch-style"></span>
							<ng-container i18n="@@newsletter">Zapisuję się na newsletter i akceptuję regulamin oraz politykę prywatności. Wyrażam zgodę na przetwarzanie moich danych osobowych przez TEMARED Sp. z o.o. z siedzibą w Świdniku zawartych w wypełnionym formularzu w celach związanych z wysyłką newslettera oraz na kontakt ze mną za pomocą środków komunikacji elektronicznej i z wykorzystaniem podanych przeze mnie danych kontaktowych, w celu marketingu bezpośredniego i w celu przekazywania informacji handlowych.</ng-container>
						</label>
						<mat-error *ngIf="form.controls.rodo.invalid && form.controls.rodo.dirty" i18n="@@rodoerror">Musisz wyrazić zgodę na przetwarzenie swoich danych osobowych.</mat-error>
					</div>
					<div class="flx-row flx-strt-cntr flx-gap-default-forced">
						<button class="flat-button primary" type="submit" [attr.disabled]="((sent | async) || (res | async) === 1 || (loading | async) == true)  ? true : null" i18n="@@send">Wyślij wiadomość</button><div *ngIf="loading | async" class="loader-circle"></div>
					</div>
				</div>			
				<p class="infobox error" *ngIf="(res | async) === 2" i18n="@@contacterror">Coś się nie udało - spróbuj jeszcze raz.</p>		
				<div class="w-100 text-center gutter gutter-v success" *ngIf="(res | async) === 1">
					<h2 i18n="@@distthank">Dziękujemy za kontakt</h2>
					<p i18n="@@seeya">Do zobaczenia na placu</p>
				</div>
			</form>
		</div>

		<div #mapwrap class="w-50-md" *ngIf="isBrowser && mapLoaded$ | async">
			<header class="flx-row flx-btwn-cntr">
				<div class="flx-col">
				<h4 i18n="@@distrib_title_map1">Mapa</h4>
				<h2 i18n="@@distrib_title_map2">Gdzie nas znajdziesz?</h2>
				</div>
				<div class="flx-row flx-gap-half">
					<a *ngIf="(distributor | async).social_1" [href]="(distributor | async).social_1" target="_blank"><svg class="icon icon-facebook-square">
						<use xlink:href="#icon-facebook-square"></use>
						</svg>
					</a>
					<a *ngIf="(distributor | async).social_2" [href]="(distributor | async).social_2" target="_blank"><svg class="icon icon-instagram">
						<use xlink:href="#icon-instagram"></use>
						</svg>
					</a>
					<a *ngIf="(distributor | async).social_3" [href]="(distributor | async).social_3" target="_blank"><svg class="icon icon-youtube-squaree">
						<use xlink:href="#icon-youtube-square"></use>
					</svg></a>
					<a *ngIf="(distributor | async).social_4" [href]="(distributor | async).social_4" target="_blank"><svg class="icon icon-globe"><use xlink:href="#icon-globe"></use></svg></a>
				</div>
			</header>
			<google-map
			width="100%"
			height="100%"
			[zoom]="zoom"
			[center]="center"
			[options]="options">
			<map-marker #somemarker="mapMarker" *ngIf="(distributor | async)"
			[options]="{icon: ((distributor | async).buttontext == 'gold' ? '/assets/map_gold.png' : '/assets/map_red.png')}"
			[position]="{lat: +(distributor | async).horizontalalign ,lng: +(distributor | async).verticalalign}">
			</map-marker>
			</google-map>
		</div>
	</div>

</div>
<div class="gutter flx-col flx-gap-default hidex"  (appDeferLoad)="fetchFeatured()">
	<header class="flx-col"><h4 i18n="@@distrib_title_products1">Oferta</h4><h2 i18n="@@distrib_title_products2">Aktualnie w ofercie</h2></header>
	<swiper [slidesPerView]="4" [spaceBetween]="16" [navigation]="true" [breakpoints]="{'@0.00': {slidesPerView: 2}, '@0.75': {slidesPerView: 2}, '@1.00': {slidesPerView: 3}, '@1.50': {slidesPerView: 4}}">
		<ng-template swiperSlide *ngFor="let product of (products_featured | async).items; let j = index;">
			<app-product [product]="product"></app-product>
		</ng-template>
	</swiper>
</div>


<div class="flx-row flx-gap-default flx-cntr-cntr">
	<a *ngIf="settings.facebook_use_profile" [href]="settings.facebook_key_profile" target="_blank"
	rel="noopener noreferrer"><span i18n="@@fb">Profil Facebook</span><svg class="icon icon-facebook-square">
	<use xlink:href="#icon-facebook-square"></use>
	</svg></a>
	<a *ngIf="settings.social_instagram_toggle" [href]="settings.social_instagram" target="_blank"
	rel="noopener noreferrer"><span i18n="@@insta">Profil Instagram</span><svg class="icon icon-instagram">
	<use xlink:href="#icon-instagram"></use>
	</svg></a>
	<a *ngIf="settings.social_twitter_toggle" [href]="settings.social_twitter" target="_blank"
	rel="noopener noreferrer"><span i18n="@@twitter">Profil Twitter</span><svg class="icon icon-twitter-square">
	<use xlink:href="#icon-twitter-square"></use>
	</svg></a>
	<a *ngIf="settings.social_vimeo_toggle" [href]="settings.social_vimeo" target="_blank"
	rel="noopener noreferrer"><span i18n="@@vimeo">Profil Youtube</span><svg class="icon icon-youtube-squaree">
		<use xlink:href="#icon-youtube-square"></use>
	</svg></a>
	<a *ngIf="settings.social_pinterest_toggle" [href]="settings.social_pinterest" target="_blank"
	rel="noopener noreferrer"><span i18n="@@pinterest">Profil Linkedin</span><svg class="icon icon-linked-square">
	<use xlink:href="#icon-linked-square"></use>
	</svg></a>
</div>